import React from 'react';

import { useCancelRenewalFigo } from '../../../hooks';

import LoadingButton from '../../common/LoadingButton';

import './css/ChangeCoverageScreenPreview.css';

const ChangeCoverageButtons = ({
  containerClass = '',
  disabledPrimaryButton = false,
  loadingPrimaryButton = false,
  onClickPrimaryButton = () => { },
  onClickSecondaryButton = () => { },
  primaryText = '',
  secondaryText = '',
  successPrimaryButton = false,
}) => {
  const showCancelRenewal = useCancelRenewalFigo();

  return (
    <div
      className={`Change-coverage-preview-buttons-container ${containerClass}`}
    >
      <button
        className={`Change-coverage-preview-keep-button ${showCancelRenewal
          ? 'Change-coverage-preview-keep-button-renewal' : ''
        }`}
        onClick={onClickSecondaryButton}
        type="button"
      >
        {secondaryText}
      </button>

      <LoadingButton
        className={`Change-coverage-preview-change-button ${showCancelRenewal
          ? 'Change-coverage-preview-change-button-renewal' : ''
        }`}
        disabled={disabledPrimaryButton}
        loading={loadingPrimaryButton}
        onClick={onClickPrimaryButton}
        success={successPrimaryButton}
        text={primaryText}
      />
    </div>
  );
};

export { ChangeCoverageButtons };
